export const ENDPOINTS = {
  video: (id) => `/videos/${id}`,
  scenes: (id) => `/videos/${id}/scenes`,
  scene: (videoID, sceneID) => `/videos/${videoID}/scenes/${sceneID}`,
  duplicateScene: (videoID, sceneID) => `/videos/${videoID}/scenes/${sceneID}/duplicate`,
  media: (mediaID) => `/media/${mediaID}`,
  buildVideo: (id) => `/videos/${id}/produce`,
  importSlide: (id) => `/videos/${id}/import-file`,
  resize: (videoID, sceneID) => `/videos/${videoID}/scenes/${sceneID}/resize`,
  logo: (videoID) => `/videos/${videoID}/logo`,
  deleteSound: (soundID) => `/media/${soundID}`,
  addSoundToVideo: (videoID) => `/videos/${videoID}/sound`,
  changeVolumeVideoAndScene: (videoID) => `/videos/${videoID}/volume`,
  uploadSpeech: (videoID, sceneID) => `/videos/${videoID}/scenes/${sceneID}/voice`,
  applySceneTemplate: (videoID, sceneID, sceneTemplateID) =>
    `videos/${videoID}/scenes/${sceneID}/templates/${sceneTemplateID}`,
  applySceneTemplateForAll: (videoID, templateID) => `/videos/${videoID}/template/${templateID}`,
  arrangeScene: (videoID) => `/videos/${videoID}/arrange-scene`,
  deleteTemplate: (id) => `/templates/${id}`,
  updateSpeech: (videoID, sceneID) => `/videos/${videoID}/scenes/${sceneID}/speech`,
  createVideo: (videoID) => `/videos/${videoID}/update-from-file`,
  updateSceneContent: (videoID, sceneID) => `/videos/${videoID}/scenes/${sceneID}/update-content`,
  createSceneContent: (videoID, sceneID) => `/videos/${videoID}/scenes/${sceneID}/insert-content`,
  resetStatus: (videoID) => `/videos/${videoID}/update-all-speech-status`,
  getVoidLanguage: '/project/tts/voices',
  createScene: (videoID) => `/videos/${videoID}/scenes`
};
